import { baseApi } from "@/shared/api";
import type {
  Form100Data,
  Form10001Data,
  Form10002Data,
  Form10007Data,
  CITReportCombined,
  Form10010Response,
  Form10011Response,
} from "../types/api";

interface Form100Params {
  year: number;
  end_date?: string;
}

interface Form10007Params {
  year: number;
  as_of_date?: string;
  opening_as_of_date?: string;
}

interface Form10010Params {
  start_date: string;
  end_date: string;
  project_id?: number;
}

export const citApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCitReport: builder.query<CITReportCombined, Form100Params>({
      query: (params) => ({
        url: `/api/accounting/cit/report/`,
        method: "GET",
        params: {
          year: params.year,
          ...(params.end_date && { end_date: params.end_date }),
        },
        credentials: "include",
      }),
      providesTags: [
        { type: "Reports" as const, id: "CIT_100" },
        { type: "Reports" as const, id: "CIT_100_01" },
        { type: "Reports" as const, id: "CIT_100_02" },
      ],
    }),

    // DEPRECATED: use getCitReport instead
    getCitForm100: builder.query<Form100Data, Form100Params>({
      query: (params) => ({
        url: `/api/accounting/cit/form-100/`,
        method: "GET",
        params: {
          year: params.year,
          ...(params.end_date && { end_date: params.end_date }),
        },
        credentials: "include",
      }),
      providesTags: [{ type: "Reports" as const, id: "CIT_100" }],
    }),

    // DEPRECATED: use getCitReport instead
    getCitForm10001: builder.query<Form10001Data, Form100Params>({
      query: (params) => ({
        url: `/api/accounting/cit/form-100-01/`,
        method: "GET",
        params: {
          year: params.year,
          ...(params.end_date && { end_date: params.end_date }),
        },
        credentials: "include",
      }),
      providesTags: [{ type: "Reports" as const, id: "CIT_100_01" }],
    }),

    // DEPRECATED: use getCitReport instead
    getCitForm10002: builder.query<Form10002Data, Form100Params>({
      query: (params) => ({
        url: `/api/accounting/cit/form-100-02/`,
        method: "GET",
        params: {
          year: params.year,
          ...(params.end_date && { end_date: params.end_date }),
        },
        credentials: "include",
      }),
      providesTags: [{ type: "Reports" as const, id: "CIT_100_02" }],
    }),

    getCitForm10007: builder.query<Form10007Data, Form10007Params>({
      query: (params) => ({
        url: `/api/accounting/cit/form-100-07/`,
        method: "GET",
        params: {
          year: params.year,
          ...(params.as_of_date && { as_of_date: params.as_of_date }),
          ...(params.opening_as_of_date && { opening_as_of_date: params.opening_as_of_date }),
        },
        credentials: "include",
      }),
      providesTags: [{ type: "Reports" as const, id: "CIT_100_07" }],
    }),

    getCitForm10010: builder.query<Form10010Response, Form10010Params>({
      query: (params) => ({
        url: `/api/accounting/cit/form-100-10/`,
        method: "GET",
        params: {
          start_date: params.start_date,
          end_date: params.end_date,
          ...(params.project_id && { project_id: params.project_id }),
        },
        credentials: "include" as const,
      }),
      providesTags: [{ type: "Reports" as const, id: "CIT_100_10" }],
    }),

    getCitForm10011: builder.query<Form10011Response, Form10010Params>({
      query: (params) => ({
        url: `/api/accounting/cit/form-100-11/`,
        method: "GET",
        params: {
          start_date: params.start_date,
          end_date: params.end_date,
          ...(params.project_id && { project_id: params.project_id }),
        },
        credentials: "include" as const,
      }),
      providesTags: [{ type: "Reports" as const, id: "CIT_100_11" }],
    }),
  }),
});

export const {
  useGetCitReportQuery,
  useGetCitForm100Query,
  useGetCitForm10001Query,
  useGetCitForm10002Query,
  useGetCitForm10007Query,
  useGetCitForm10010Query,
  useGetCitForm10011Query,
} = citApi;

